export const locResultURL = 'location/results' // Gets the results based on user location(lat, long) and we use the first onw from the array.
export const locPredictionURL = 'location/predictions' // gets the predictions
export const alcoholAuthURL = 'alcohol/alcohol'
export const locPlaceIDURL = 'location/{placeId}'
export const locVerifyResURL = 'location/verify'
export const storesByLocationURL = 'location/getLoc/v2'
export const pickupStoresURL = '/location/stores'
